module.exports = {
  'kg': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.KILOGRAM',
  'g': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.GRAM',
  'mg': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.MILLIGRAM',
  'mcg': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.MICROGRAM',
  'ng': 'Nanogram',
  'mls': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.MILLILITRE',
  'ls': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.LITRE',
  'other': 'MEDICATIONS.V2.FORM.OPTION.DOSAGE_UNIT.OTHER'
};
